var $eeeaa8daee3601c7$exports = {};
$eeeaa8daee3601c7$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "V\xE4\xE4rtus peab olema ".concat(args.maxValue, " v\xF5i varasem.");
  },
  "rangeReversed": "Alguskuup\xE4ev peab olema enne l\xF5ppkuup\xE4eva.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "V\xE4\xE4rtus peab olema ".concat(args.minValue, " v\xF5i hilisem.");
  },
  "unavailableDate": "Valitud kuup\xE4ev pole saadaval."
};
export { $eeeaa8daee3601c7$exports as default };